import { axiosInstance } from '../network';
import { API_URL } from '../../constants';

export default {
    getProRole: (proid) => {
        return axiosInstance.get(`${API_URL.PRO_ROLE_CHART}/${proid}`, {
            params: { skip: 0, limit: 1000 }
        });
    },
    manageLicense: (proid, data) => {
        return axiosInstance.post(`${API_URL.MANAGE_LICENSE}/${proid}`, data);
    },
    updateLicense: (proid, id, data) => {
        return axiosInstance.put(`${API_URL.UPDATE_LICENSE}/${proid}/${id}`, data);
    },
    renewalLicense: (proid, id, data) => {
        return axiosInstance.patch(`${API_URL.UPDATE_LICENSE}/${proid}/${id}`, data);
    },
    fileUpload: (data) => {
        return axiosInstance.post(API_URL.FILE_UPLOAD, data, {
            headers: {
                'Content-Type': 'application/form-data',
                isAuthRequired: true
            }
        });
    },
    headerImage: (id) => {
        return axiosInstance.get(`${API_URL.HEADER_IMAGE}/${id}`, {
            params: { file_type: 'bill_header' }
        });
    },
    getbusinessId: (proid, id) => {
        return axiosInstance.get(`${API_URL.GET_BUSINESSUUID}/${proid}/${id}`);
    },
    getLicensebusinessId: (proid, id) => {
        return axiosInstance.get(`${API_URL.GET_LICENSEBUSINESSUUID}/${proid}/${id}`, {
            params: { skip: 0, limit: 10 }
        });
    },
    getLicensebusinesslicenseId: (proid, id, uuid) => {
        return axiosInstance.get(`${API_URL.GET_LICENSEBUSINESSUUID}/${proid}/${id}/${uuid}`, {
            params: { skip: 0, limit: 10 }
        });
    },
    getmasterrole: (id) => {
        return axiosInstance.get(`${API_URL.GETALL_MASTERROLE}/${id}`);
    },
    getalluser: () => {
        return axiosInstance.get(API_URL.GETALL_USER);
    },
    useridentity: (id, data) => {
        return axiosInstance.post(`${API_URL.USER_IDENTITY}/${id}`, data);
    },
    userEdit: (id, data) => {
        return axiosInstance.put(`${API_URL.USER_EDIT}/${id}`, data);
    },
    getallusermapping: (pid, id, page, pageSize) => {
        return axiosInstance.get(`${API_URL.GETALL_USERMAPPING}/${pid}/${id}`, {
            params: { skip: page, limit: pageSize }
        });
    },
    getusermappingdata: (pid, id, uuid) => {
        return axiosInstance.get(`${API_URL.GETALL_USERMAPPING}/${pid}/${id}`, {
            params: { user_uuid: uuid }
        });
    },
    getimage: (id, fileId) => {
        return axiosInstance.get(`${API_URL.GET_SAVEDIMAGE}/${id}/${fileId}`);
    },

    getbillfronteditPreview: (proid, id, uuid, template_name, language) => {
        return axiosInstance.get(`${API_URL.FRONTPREVIEW_EDIT}/${proid}/${id}/${uuid}`, {
            params: { language: language, template_name: template_name, skip: 0, limit: 10 }
        });
    },

    updateFrontPreview: (proid, id, data) => {
        return axiosInstance.put(`${API_URL.FRONTPREVIEW_EDITUPDATE}/${proid}/${id}`, {
            customization_field: data
        });
    },
    getPrint: (productUid, tempName, LicId, replace, usedFor) => {
        return axiosInstance.get(`${API_URL.GET_PRINT}/${productUid}/${tempName}/${LicId}`, {
            params: {
                preview_mode: replace,
                used_for: usedFor
            }
        });
    },
    postPrint: (productUid, data) => {
        return axiosInstance.post(`${API_URL.POST_PRINT}/${productUid}`, data);
    },
    updatePrint: (productUid, tempUid, data) => {
        return axiosInstance.patch(`${API_URL.UPDATE_PRINT}/${productUid}/${tempUid}`, data);
    },
    updateInformation: (businessId, data) => {
        return axiosInstance.patch(`${API_URL.PLAN_BUSINESSNAME}/${businessId}`, data);
    }
};
